export default __webpack_public_path__ + "static/media/CT_Phonedata.384ab69e.png";